var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1H2.5C1.39543 1 0.5 1.89543 0.5 3V17C0.5 18.1046 1.39543 19 2.5 19H16.5C17.6046 19 18.5 18.1046 18.5 17V3C18.5 1.89543 17.6046 1 16.5 1Z",
    fill: "white",
    stroke: "#141218",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22012 8.03997C5.9657 8.03997 6.57012 7.43555 6.57012 6.68997C6.57012 5.94438 5.9657 5.33997 5.22012 5.33997C4.47453 5.33997 3.87012 5.94438 3.87012 6.68997C3.87012 7.43555 4.47453 8.03997 5.22012 8.03997Z",
    fill: "#141218"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8590_115882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 19,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1H2.5C1.39543 1 0.5 1.89543 0.5 3V17C0.5 18.1046 1.39543 19 2.5 19H16.5C17.6046 19 18.5 18.1046 18.5 17V3C18.5 1.89543 17.6046 1 16.5 1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8590_115882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4201 14.43V16.25C19.4201 17.74 18.2101 18.96 16.7201 18.96H2.28008C0.790078 18.96 -0.419922 17.74 -0.419922 16.25C1.19008 14.9 3.10008 12.7 3.87008 12.16C4.06008 12.03 4.30008 12.03 4.50008 12.16L5.57008 13.21C6.09008 13.72 6.55008 13.63 6.86008 13.36C8.17008 12.19 11.4401 8.86001 12.3301 7.79001C12.5101 7.58001 12.8201 7.57001 13.0101 7.76001C14.1001 8.89001 17.4601 12.36 19.4201 14.44V14.43Z",
    fill: "#141218"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default_icon.cd4f7294796aaf0ea2f6f845bc219a15.svg";
export { ForwardRef as ReactComponent };